import PageMeta from './page-meta';

export { PageMeta };
